import * as React from 'react';
import * as moment_timezone from 'moment-timezone';
import { Event } from '../calendar/calendar.event.types';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import RaisedButton from 'material-ui/RaisedButton';
import './calendar.css';
import { 
    AGENDA_VIEW, 
    DAY_VIEW, 
    WEEK_VIEW, 
    MONTH_VIEW, 
    CALENDAR_EVENT_SELECTED, 
    CREATE_CALENDAR_EVENT 
} from '../calendar/calendar.constants';
import { createMinMaxTime, createMaxTime, createMinTime } from '../calendar/calendar.util';
import { cannotWrite } from '../util/permission.util';
import { AuthState } from '../auth/auth.types';
import { AdminState } from '../admin/admin.types';
import { PROGRAM } from '../account/Constants';
import { mmsStore } from '../app/app.config';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import {
    AttendanceState,
    Attendance,
    CheckinState,
    FilterOption,
    AttendanceDetail,
    AttendanceDetails
  } from './attendance.types';
import { getLocalMoment, dateFromString, dateFromTimeString } from 'src/util/date-util';
import { Dialog, TextField } from 'material-ui';
import ReactTable from 'react-table';
import PaymentsDetailsModal from 'src/payments/paymentsDetailsModal';
import moment = require('moment');
import { ProgramsState, Schedule, Program } from 'src/programs/Types';
import { PackageState } from 'src/mms-package/Types';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import { Member } from 'src/members/members.types';
import { View } from 'react-big-calendar';
import { CommunicationStayPrimaryLandscape } from 'material-ui/svg-icons';
import { overlayStyle, renderOverlayLoading } from 'src/util/Overlay';

const BigCalendar = require('react-big-calendar');
const DEFAULT_COLOR = '#0b9cd5';

type Props = {
    readonly selectedMember: Member
    readonly authState: AuthState
    readonly attendanceState: AttendanceState
    readonly adminState: AdminState
    readonly programState: ProgramsState
    readonly packageState: PackageState
    readonly getAttendance: (from: number, to: number) => Promise<Response>
    readonly applyFilter: Function
    readonly getMonthlyTotalForSelectedMember: Function
    readonly withProgram: boolean
};

type States = {
    readonly start: Date
    readonly events: Array<Event>
    readonly calendarMode: string
    readonly selectedEvent: Event
    readonly openModal: boolean
    readonly loadedAttendances: boolean
    readonly filterText: string
};

class Calendar extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      start: getLocalMoment(new Date()).toDate(),
      events: [],
      calendarMode: MONTH_VIEW,
      selectedEvent: {id: 0, title: ''},
      openModal: false,
      loadedAttendances: false,
      filterText: ''
    };

    BigCalendar.momentLocalizer(moment_timezone);
    this.pickColorForEvent = this.pickColorForEvent.bind(this);
    this.handleSelectEvent = this.handleSelectEvent.bind(this);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.attendanceState !== prevProps.attendanceState) {
      this.setState({loadedAttendances: true});
      this.props.getMonthlyTotalForSelectedMember(this.props.applyFilter());
    }
  }

  render() {
    return (
      <div>
        {this.renderCalendar()}
      </div>
    );
  }

  private renderCalendar = (): JSX.Element => {
    const { start, calendarMode, openModal, loadedAttendances } = this.state;
    const attendanceState = this.props.attendanceState;

    return (
        <div className="vh-75" style={overlayStyle(loadedAttendances)}>
          {renderOverlayLoading(loadedAttendances, '25%')}
          <BigCalendar
            selectable={true}
            events={calendarMode === MONTH_VIEW ? 
              this.createEventsToDisplayForMonthView(attendanceState.attendance === undefined ? [] : 
                this.props.applyFilter()) 
              : this.createEventsToDisplayForWeekView(attendanceState.attendance === undefined ? [] : 
                this.props.applyFilter())}
            defaltView={MONTH_VIEW}
            views={[WEEK_VIEW, MONTH_VIEW]}
            min={createMinTime(0, start)}
            max={createMaxTime(23, start)}
            messages={{allDay: ''}}
            eventPropGetter={this.pickColorForEvent}
            className="pa2"
            onSelectEvent={this.handleSelectEvent}
            onNavigate={this.handleOnNavigation}
            onView={this.handleOnView}
          />
          <Dialog
            title="Attended Members"
            open={openModal}
            modal={false}
            onRequestClose={this.handleClose}
            contentStyle={{
              width: '80%',
              maxWidth: 'none',
            }}
            autoScrollBodyContent={true}
          >
            <div className="text-center">
              <TextField
                className="w-50"
                hintText="Search By Name"
                floatingLabelText="Search"
                onChange={this.onFilterTextChange}
              />
            </div>
            <ReactTable
              data={this.createDataForModalTable()}
              columns={[
                {
                  Header: 'Name',
                  accessor: 'name',
                  style: {textAlign: 'left', marginLeft: '10px'}
                },
                {
                  Header: 'Phone',
                  accessor: 'phone',
                  style: {textAlign: 'left', marginLeft: '10px'}
                },
                {
                  Header: 'Time',
                  accessor: 'time',
                  sortMethod: (a, b, desc) => {
                    if (dateFromTimeString(a) > dateFromTimeString(b)) {
                      return 1;
                    } else if (dateFromTimeString(a) < dateFromTimeString(b)) {
                      return -1;
                    } else {
                      return 0;
                    }
                  },
                  style: {textAlign: 'center'}
                },
                {
                  Header: 'Program',
                  accessor: 'program',
                  style: {textAlign: 'left', marginLeft: '10px'}
                },
                {
                  Header: 'Description',
                  accessor: 'description',
                  style: {textAlign: 'left', marginLeft: '10px'}
                },
                {
                  Header: 'No Show',
                  accessor: 'noshow',
                  style: {textAlign: 'center'}
                }]
              }
              defaultPageSize={20}
              showPageSizeOptions={false}
              className="-striped -highlight"
            />
          </Dialog>
        </div>
      );
  }

  private createEventsToDisplayForMonthView = (attendances: Array<Attendance>): Array<Event> => {
    if (attendances === undefined) {
      return [];
    }
    var attendacesByDate = {};
    for (var i = 0; i < attendances.length; i++) {
        var attendance = attendances[i];
        var date = this.state.start, y = date.getFullYear(), m = date.getMonth();
        var firstDay = new Date(y, m, 1);
        var lastDay = new Date(y, m + 1, 0);
        var index = 0;
        while (firstDay.getTime() <= lastDay.getTime()) {
            if (attendance.attendanceDetails[firstDay.getDate()]) { 
                if (!attendacesByDate[firstDay.getTime()]) {
                    attendacesByDate[firstDay.getTime()] = [];
                }
                attendance.attendanceDetails[firstDay.getDate()].forEach(function(attendanceDetail) {
                    attendacesByDate[firstDay.getTime()].push(attendanceDetail);
                    }
                );
            }
            firstDay.setDate(firstDay.getDate() + 1);
        }
    }

    var events = [];
    for (var key in attendacesByDate) {
        if (attendacesByDate[key]) {
            var details = attendacesByDate[key];
            events.push({
                id: 0,
                title: details.length + '',
                start: new Date(Number(key)),
                end: new Date(Number(key) + 3600000),
                backgroundColor: '#9d9ea1',
                attendanceDetails: details
            });
        }
    }

    return events;
  }

  private createEventsToDisplayForWeekView = (attendances: Array<Attendance>): Array<Event> => {
    if (attendances === undefined) {
      return [];
    }
    var attendacesByTime = {};
    for (var i = 0; i < attendances.length; i++) {
        var attendance = attendances[i];
        var date = this.state.start;
        var diff = date.getDate() - date.getDay();
        var firstDay = new Date(date.setDate(diff));
        firstDay.setHours(0, 0, 0, 0);
        diff = date.getDate() - date.getDay() + 6;
        var lastDay = new Date(date.setDate(diff));
        lastDay.setHours(23, 59, 59, 999);
        while (firstDay.getTime() <= lastDay.getTime()) {
          if (attendacesByTime[firstDay.getTime()] === undefined) {
            attendacesByTime[firstDay.getTime()] = [];
          }
          if (attendance.attendanceDetails[firstDay.getDate()]) { 
              attendance.attendanceDetails[firstDay.getDate()].forEach(function(attendanceDetail) {
                if (attendanceDetail.time >= firstDay.getTime() &&
                    attendanceDetail.time < firstDay.getTime() + 3600000) {
                      attendacesByTime[firstDay.getTime()].push(attendanceDetail);
                  }
              }
            );
          }
          firstDay.setTime(firstDay.getTime() + 3600000);
        }
    }

    var events = [];
    if (this.props.withProgram) {
      events = events.concat(this.createEventsToDisplay(this.props.programState.programs));
    }
    for (var key in attendacesByTime) {
        if (attendacesByTime[key] && attendacesByTime[key].length > 0) {
            var details = attendacesByTime[key];
            events.push({
                id: 0,
                title: details.length + '',
                start: new Date(Number(key)),
                end: new Date(Number(key) + 3600000),
                backgroundColor: '#9d9ea1',
                attendanceDetails: details
            });
        }
    }

    return events;
  }

  private createDataForModalTable = () => {
    const { selectedEvent } = this.state;
    const { programState, packageState } = this.props;

    var attendances = this.props.applyFilter();
    var result = [];
    var details = selectedEvent.attendanceDetails;
    if (details !== undefined) {
      for (var i = 0; i < details.length; i++) {
        var attendance = attendances.find(att => att.memberId === details[i].memberId);
        var program = programState.programs.find(pg => pg.id === details[i].programId);
        var pkg = packageState.packages.find(pack => pack.id === details[i].packageId);
        if (attendance !== undefined && this.applyNameFilter(attendance.name)) {
          result.push({
            name: attendance.name,
            phone: attendance.phone,
            time: moment(new Date(details[i].time)).format('hh:mm a'),
            program: program === undefined ? '' : program.name,
            description: pkg === undefined ? '' : pkg.description,
            noshow: details[i].noShow !== undefined ? details[i].noShow ? <CheckCircle /> : '' : ''
          });
        }
      }
    }
    return result;
  }

  private applyNameFilter = (name: string): boolean => {
    const { filterText } = this.state;
    if (filterText === '') {
      return true;
    } else {
      return name.toLowerCase().includes(filterText.toLowerCase());
    }
  }

  private onFilterTextChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    this.setState(
      {
        filterText: newValue.toLowerCase()
      }
    );
  }

  private pickColorForEvent = (event: Event, start: Date, end: Date, isSelected: boolean) => {
    return {
      style: {
        backgroundColor: event.backgroundColor
      }
    };
  }
  private handleOnNavigation = (date: Date): void => {
    this.setState({start: getLocalMoment(date).toDate(), loadedAttendances: false });
    this.getAttendancesWithDates(getLocalMoment(date).toDate(), this.state.calendarMode);
  }

  private handleOnView = (view: View): void => {
    this.setState({ calendarMode: view, loadedAttendances: false });
    this.getAttendancesWithDates(this.state.start, view);
  }

  private handleSelectEvent = (event: Event): void => {
    if (event.attendanceDetails) {
      this.setState({ openModal: true, selectedEvent: event });
    }
  }

  private handleClose = (): void => {
    this.setState({openModal: false});
  }

  private createEventsToDisplay = (programs: Array<Program>): Array<Event> => {
    const newPrograms: Array<Array<Event>> = programs
      .map((program: Program) => this.createEventToDisplay(program));
      
    return [].concat.apply([], newPrograms);
  }
  private createEventToDisplay = (program: Program): Array<Event> => {
    var today = getLocalMoment(new Date());
    var date = getLocalMoment(this.state.start);
    return program.schedules
      .map((schedule: Schedule) => {
      return {
        id: program.id,
        title: program.name,
        start: schedule.startDate ? getLocalMoment(new Date(schedule.startDate - 
          ((today.week() - date.week()) * 604800000))).toDate() : undefined,
        end: schedule.endDate ? getLocalMoment(new Date(schedule.endDate - 
          ((today.week() - date.week()) * 604800000))).toDate() : undefined,
        backgroundColor: program.colorValue ? program.colorValue : DEFAULT_COLOR
      };
    });
  }

  private getAttendancesWithDates = (date: Date, view: string): void => {
    var from;
    var to;
    if (view === 'month') {
      from = new Date(date.getFullYear(), 
      date.getMonth(), 1, 0, 0, 0, 0);
      to = new Date(date.getFullYear(), 
      date.getMonth() + 1, 0, 23, 59, 59, 999);
    } else {
      var diff = date.getDate() - date.getDay();
      from = new Date(date.setDate(diff));
      from.setHours(0, 0, 0, 0);
      diff = date.getDate() - date.getDay() + 6;
      to = new Date(date.setDate(diff));
      to.setHours(23, 59, 59, 999);
    }
    this.props.getAttendance(from.getTime(), to.getTime());
  }
}

export default Calendar;


// WEBPACK FOOTER //
// ./src/attendance/CalendarComponent.tsx